import React, { createContext, useEffect, useState } from "react";
import { IAdvisorContextType } from "../types/interfaces/IAdvisorContextType";
import { IAdvisorProviderProps } from "../types/interfaces/IAdvisorProviderProps";
import { IIndividualLearningPlan } from "../types/interfaces/IIndividualLearningPlan";
import { IReviewerView } from "../types/interfaces/IReviewerView";
import { useDuesSponsoredOrgContext } from '../../global/hooks/useDuesSponsoredOrgContext';
import useGetPlansByOrg from "../hooks/useGetPlansByOrg";

//The advisor context object holds the latest value of the state.
export const AdvisorContext = createContext<IAdvisorContextType | undefined>(undefined);

//This component is responsible to share the advisor data between components.
export const AdvisorProvider: React.FC<IAdvisorProviderProps> = ({ children }) => {
    const [reviewerViewArray, setReviewerViewArray] = useState<IReviewerView[] | null>(null);
    const [individualLearningPlan, setIndividualLearningPlan] = useState<IIndividualLearningPlan | null>(null);
    const [loadingAdvisorCtx, setLoadingAdvisorCtx] = useState<boolean>(true);
    const { selectedOrganization } = useDuesSponsoredOrgContext();
    const [fetchPlans] = useGetPlansByOrg();

    useEffect(() => {
        try {
            if (selectedOrganization) {
                const fetchAndSetPlans = async () => {
                    setLoadingAdvisorCtx(true);
                    const fetchedPlans = await fetchPlans();
                    setReviewerViewArray(fetchedPlans);
                    setLoadingAdvisorCtx(false);
                };
                fetchAndSetPlans();
            }
            else {
                setLoadingAdvisorCtx(false);
            }
        }
        catch (error: any) {
            console.log('get error', error);
            setLoadingAdvisorCtx(false);
        }
    }, [selectedOrganization]);

    const value = {
        reviewerViewArray,
        individualLearningPlan,
        loadingAdvisorCtx,
        setReviewerViewArray,
        setIndividualLearningPlan
    }

    return (
        <AdvisorContext.Provider value={value}>
            {!loadingAdvisorCtx && (children)}
        </AdvisorContext.Provider>
    );
}